window.addEventListener('load', function(e) {

	// target the right page
	if (!document.body.classList.contains('wachtwoord-vergeten')) {
		return;
	}

	init();

	// References to the elements on the page
	var btnPasnummer;
	var btnEmailAdres;
	var formSectionPasnummer;
	var formSectionEmail;

	/**
	 * Initializes the page
	 */
	function init() {
		getELements();
		addHandlers();
	}

	/**
	 * Gets references to the elements on the page
	 */
	function getELements() {
		btnPasnummer = document.getElementById('btn-pasnummer');
		btnEmailAdres = document.getElementById('btn-email');;
		formSectionPasnummer = document.getElementById('form-section-passnummer')
		formSectionEmail = document.getElementById('form-section-email')
	}

	/**
	 * Sets event listeners for the page
	 */
	function addHandlers() {
		btnPasnummer.addEventListener('click', onClickBtnPasnummer);
		btnEmailAdres.addEventListener('click', onClickBtnEmail);
	}

	/**
	 * Handler for the click event of the pasnummer button
	 * @param {EventObject} e The click event
	 */
	function onClickBtnPasnummer(e) {
		var isPressed = btnPasnummer.getAttribute('aria-pressed') === 'true';
		btnPasnummer.setAttribute('aria-pressed', !isPressed);
		btnEmailAdres.setAttribute('aria-pressed', 'false');

		formSectionEmail.style.display = 'none';
		formSectionPasnummer.style.display = isPressed ? 'none' : 'block';
	}

	/**
	 * Handler for the click event of the email button
	 * @param {EventObject} e The click event
	 */
	function onClickBtnEmail(e) {
		var isPressed = btnEmailAdres.getAttribute('aria-pressed') === 'true';
		btnEmailAdres.setAttribute('aria-pressed', !isPressed);
		btnPasnummer.setAttribute('aria-pressed', 'false');

		formSectionPasnummer.style.display = 'none';
		formSectionEmail.style.display = isPressed ? 'none' : 'block';
	}

});
